import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { saveSession, clearSession, getStoredUser, getAccessToken } from "@/lib/auth";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getStoredUser());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getAccessToken();
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        setUser(res.data);
        localStorage.setItem("dcc_user", JSON.stringify(res.data));
      })
      .catch(() => {
        clearSession();
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = (payload) => {
    saveSession(payload);
    setUser(payload.user);
  };

  const refreshUser = async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
      localStorage.setItem("dcc_user", JSON.stringify(res.data));
      return res.data;
    } catch (e) { return null; }
  };

  const logout = async () => {
    // 1) Best-effort: revoke refresh token server-side (ignore errors).
    try { await api.post("/auth/logout"); } catch (_e) { /* noop */ }
    // 2) Local cleanup (all app-scoped keys).
    clearSession();
    try {
      localStorage.removeItem("dcc_agent_conv");
      localStorage.removeItem("dcc_agent_state");
    } catch (_) { /* SSR-safe */ }
    setUser(null);
    // 3) Hard redirect: guarantees ALL React state (context providers, caches,
    //    background pollers) are reset even from within nested components.
    try { toast.success("Sesión cerrada"); } catch (_) {}
    // Use assign() to force a full navigation from any route (public or private).
    if (typeof window !== "undefined") {
      window.location.assign("/login");
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
